import { getPageData, userDataAnalytics } from './adobe-analytics-utils';
import { TrackLinkParams } from './eclaims-adobe-analytics-model';

const ADOBE_LINK_CLICK = 'link_click';
const ADOBE_PAGE_LOAD = 'page_load';

export const ADOBE_TRANSACTION_START = 'transaction_start';
export const ADOBE_TRANSACTION_STEP = 'transaction_step';
export const ADOBE_TRANSACTION_COMPLETE = 'transaction_complete';
export const ADOBE_TRANSACTION_ERROR = 'transaction_error';

declare global {
  interface Window {
    adobeDataLayer: any;
  }
}
declare const window: Window &
  typeof globalThis & {
    adobeDataLayer: any;
  };

window.adobeDataLayer = [];
const dataLayer = window.adobeDataLayer;

/**
 * Function to track page view/loading via adobe analytics
 * @param pageName name of the page i.e. loaded
 */
export async function trackPageLoad(pageName: string) {
  dataLayer.push(
    {
      event: ADOBE_PAGE_LOAD,
      page: getPageData(pageName),
      user: await userDataAnalytics({ id: '' }),
      policy: [
        {
          type: '',
          name: 'eclaims',
          number: '',
        },
      ],
    }
  );
}


/**
 * Function to track link click via adobe analytics
 * @param type type of link whether it's internal or external
 * @param params parameters to be send to tracking event
 */
export function trackLinkClick(params: TrackLinkParams) {
  let eventInfo;
  eventInfo = {
    event: ADOBE_LINK_CLICK,
    eventInfo: {
      click: {
        linkName: params?.label,
        linkHref: params?.url || '',
      },
    },
  };
  dataLayer.push(eventInfo);
}


export function trackTransactions(transactionEvent: 'transaction_start' | 'transaction_step' | 'transaction_complete' | 'transaction_error', transactionName: string) {
  const eventInfo = {
    event: transactionEvent,
    eventInfo: {
      transaction: {
        transactionName: transactionName
      },
    },
  };

  dataLayer.push(eventInfo);
}


export * as EclaimsAdobeAnalytics from './eclaims-adobe-analytics';

